// omit and pick https://gist.github.com/bisubus/2da8af7e801ffd813fab7ac221aa7afc
export function omit(obj: any, keys: any) {
  return Object.entries(obj)
    .filter(([key]) => !keys.includes(key))
    .reduce((_obj, [key, val]) => Object.assign(_obj, { [key]: val }), {});
}
